module.exports = __webpack_public_path__ + "static/media/time-session-30.f0abc415.svg";